module.exports = __webpack_public_path__ + "static/promenade-920af0a670ef917bc7ff075d48ce1da0.jpg";